<script lang="js" setup>
import { useSpotStore } from '~/store/spot'
import { usePanelStore } from '~/store/spot/panel'
import { fix, toHuman } from '~/utils/math'

const props = defineProps({
  side: {
    type: Number,
    default: 1,
  },
  list: {
    type: Array,
    default: () => [],
  },
  max: {
    type: Number,
    default: null,
  },
  dp: {
    type: Number,
    default: 0,
  },
  data: {
    type: Object,
    default: () => ({
      list: [],
    }),
  },
})
defineEmits(['clickItem'])

const spot = useSpotStore()
const panel = usePanelStore()
const isBuy = computed(() => props.side === 1)
const ls = computed(() => isBuy.value ? props.list.toReversed() : props.list) // 翻转买单是为了 使用css: ~选择器

function setPanelPrice(v) {
  if (panel.isLimit && panel.priceType === 'DEFAULT') {
    panel.price = v
  }
}
</script>

<template>
  <div class="flex flex-col" :class="{ 'flex-col-reverse': isBuy }">
    <common-x-tips-simple
      v-for="(i, j) in ls"
      :key="j"
      placement="left"
      :disabled="!+i.qty"
      content-class="!px-2 !py-1"
    >
      <template #content>
        <ul class="min-w-[200px] text-sm text-textPrimary space-y-1">
          <li class="flex justify-between">
            <span>{{ $t('均价') }}</span>
            <span>{{ toHuman(i.ap, spot.ps, undefined, { usingGroup: true }) }}</span>
          </li>
          <li class="flex justify-between">
            <span>{{ $t('累计{0}', [spot.base]) }}</span>
            <span>{{ toHuman(i.t, spot.as, undefined, { usingGroup: true }) }}</span>
          </li>
          <li class="flex justify-between">
            <span>{{ $t('累计{0}', [spot.quote]) }}</span>
            <span>{{ toHuman(i.ta, spot.as, undefined, { usingGroup: true }) }}</span>
          </li>
        </ul>
      </template>
      <div
        class="py-px px-3 peer hover:border-dashed  hover:border-tooltip hover:bg-inputDefault [&:hover~div]:bg-inputDefault"
        :class="[isBuy ? 'hover:border-b-[0.5px]' : 'hover:border-t-[0.5px]']"
        @click="setPanelPrice(i.p)"
      >
        <div class="relative flex items-center py-px h-4 cursor-pointer select-none text-[9px]">
          <b class="absolute top-0 right-0 w-full h-full duration-[300ms] transition-transform origin-right scale-0 opacity-[0.15]" :class="[isBuy ? 'bg-buy' : 'bg-sell']" :style="{ transform: `scaleX(${max ? ((i.qty || 0) / max).toFixed(2) : 0})` }" />
          <b v-if="i.mark" class="absolute block w-1 h-1 rounded-full -start-2 top-[6px]" :class="[isBuy ? 'bg-buy' : 'bg-sell']" />
          <span class="relative w-[80px] text-start" :class="[isBuy ? 'text-buy' : 'text-sell']">{{ fix(i.p, dp) }}</span>
          <span class="relative w-[88px] px-1">{{ toHuman(i.qty, spot.as, undefined, { usingGroup: true }) }}</span>
          <span class="relative w-[88px]">{{ toHuman(i.t, spot.as, undefined, { usingGroup: true }) }}</span>
        </div>
      </div>
    </common-x-tips-simple>
  </div>
</template>
